import { ContractStatusEnum } from '@shared/enums/contract-status.enum';

import { Badge } from '@web/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@web/components/ui/tooltip';

const contractStatusColorClassName = (status: ContractStatusEnum) => {
  switch (status) {
    case 'draft':
      return 'bg-slate-400'; // Draft is a work in progress
    case 'sent':
      return 'bg-blue-400'; // Sent indicates action taken, using blue for info
    case 'viewed':
      return 'bg-blue-500'; // Viewed is a progression from sent
    case 'signed':
      return 'bg-green-500'; // Signed is positive progress
    case 'declined':
      return 'bg-red-500'; // Declined is negative/error state
    case 'deposit':
      return 'bg-emerald-500'; // Initial deposit paid
    case 'paid':
      return 'bg-emerald-600'; // Paid is successful completion
    case 'expired':
      return 'bg-amber-400'; // Expired is a warning state
    case 'voided':
      return 'bg-red-400'; // Voided is negative but less severe than declined
    case 'closed':
      return 'bg-amber-600'; // Completed is ultimate success
    case 'completed':
      return 'bg-green-800'; // Surgery completed - final success state
  }
};

const tooltip = (status: ContractStatusEnum) => {
  switch (status) {
    case 'draft':
      return 'The contract is a draft and can be edited';
    case 'sent':
      return 'The contract has been sent';
    case 'viewed':
      return 'The contract has been viewed';
    case 'signed':
      return 'The contract has been signed';
    case 'declined':
      return 'The customer has declined the contract';
    case 'deposit':
      return 'The initial deposit has been paid';
    case 'paid':
      return 'The contract has been fully paid';
    case 'expired':
      return 'The e-contract has expired';
    case 'voided':
      return 'The e-contract is no longer valid';
    case 'closed':
      return 'The contract is signed and initial deposit received';
    case 'completed':
      return 'The customer has undergone surgery';
  }
};

export function ContractStatusBadge({
  status,
}: {
  status: ContractStatusEnum;
}) {
  return (
    <Tooltip>
      <TooltipTrigger>
        <Badge className={contractStatusColorClassName(status)}>{status}</Badge>
      </TooltipTrigger>

      <TooltipContent className="bg-card text-foreground shadow-sm">
        {tooltip(status)}
      </TooltipContent>
    </Tooltip>
  );
}
